import React from 'react';
import { SafetyDataSheetReplacement } from '@pages/SafetyDatasheet/SafetyDatasheet.types';

const formatProductName = (productName: string, productItemNumber: string): string => {
  if (productName && productItemNumber) {
    return `${productName} - ${productItemNumber}`;
  }
  return productName || productItemNumber || '';
};

export const ReplacementTitle = ({
  label,
  items,
}: {
  label: string;
  items: SafetyDataSheetReplacement[];
}) => {
  const replaceItems = items.map((item) => {
    return formatProductName(item.Name, item.ItemNumber);
  });

  return (
    <>
      <br></br>
      <strong className='c-document-title-small'>{label}</strong>&nbsp;
      <span className='c-document-title-small'>{replaceItems.join(', ')}</span>
    </>
  );
};
